import { Validators } from '@angular/forms';
import { TableCols } from '../interfaces/static-data';

export const BENEFIT_KEY: TableCols[] = [
  {
    key: 'value',
    displayValue: 'Value',
    type: "number",
    validators: [Validators.required],
  },
  {
    key: 'benefitKey',
    displayValue: 'Benefit Key',
    validators: [Validators.required, Validators.minLength(2), Validators.maxLength(2)],
  },
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  }
];
